import { string, oneOf } from 'prop-types';
import React from 'react';

import styles from './notification.module.css';
import { notificationType } from '../../constants/types';

const getContainerStyle = (type) => {
  switch (type) {
    case notificationType.WARNING:
      return styles.warning;
    case notificationType.ERROR:
      return styles.error;
    case notificationType.ALERT:
      return styles.ALERT;
    default:
      return styles.info;
  }
};

const getIcon = (type) => {
  switch (type) {
    case notificationType.WARNING:
      return 'icon--alert';
    case notificationType.ERROR:
      return 'icon--alert';
    case notificationType.OK:
      return 'icon--done';
    default:
      return 'icon--info-stroke';
  }
};

const Notification = ({ text, type }) => (
  <div className={`${getContainerStyle(type)} ${styles.container}`}>
    <span className={`${getIcon(type)}`} aria-hidden />
    <p>{text}</p>
  </div>
);

Notification.propTypes = {
  text: string.isRequired,
  type: oneOf(Object.values(notificationType))
};

Notification.defaultProps = {
  type: notificationType.INFO
};

export default Notification;
